export default __webpack_public_path__ + "static/Answer, summarise, prioritise-37f34b47b4ee3a35a8f5524dfc5c2a89.png";